import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button,FormGroup } from "react-bootstrap";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import 'components/sales/layoutChange/layout.css';
import './vendorstyle.css';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import FileUpload from "components/sales/fileUpload/fileUpload";
import * as moment from "moment";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DivLayout from 'components/sales/divLayout/divLayout';
import DocumentView from 'components/sales/downloadDocView/documentView';
import { set } from "date-fns";


const PaymentDetails = ({
  getVendorPaymentRequestDetail,
  dataList,
  approvalVendorPaymentRequest,
  match,
  history,
}) => {
  const [teamId, setTeamId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isFocus1, setIsFous1] = useState(true);
  const [departmentId, setDepartmentId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [requestAmt, setRequestAmt] = useState('');
  const [pendingAmt, setPendingAmt] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [savedStatus, setSavedStatus] = useState('');
  const [isModalPO, setIsModalPO] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [modelForHold, setModelForHold] = useState(false);
  const [remark, setRemark] = useState('');
  const [isHoldModal, setIsHoldModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [holdStatus, setHoldStatus] = useState(0);
  const [makeStatus,setMakeStatus] = useState(null);
  const [modelHeader, setModelHeader] = useState(null);
  const [checkMSME, setCheckMSME] = useState(false);
  const [msmeMsg,setMSMEMsg] = useState('');

  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  
  useEffect(() => {
    localStorage.setItem('redirect', '');
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);


  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (match?.params?.id) {
    
      (async () => {
        setIsLoading(true);
        await getVendorPaymentRequestDetail(match?.params?.id);
        setIsLoading(false);
      })();
    
  }
  }, [getVendorPaymentRequestDetail]);

  useEffect(() => {
    if(dataList.invoice_data?.total_amount){
      var totalAmt = dataList.invoice_data?.total_amount;
      var reqAmt = dataList.invoice_data?.request_amount;
      var pendingAmt = Number(totalAmt) - Number(reqAmt)
      setPendingAmt(pendingAmt);
    }
    setIsUpdate(false);
    setHoldStatus(0);
    if(dataList?.invoice_data?.status === 'Hold'){
        setIsUpdate(true);
        setHoldStatus(7);
    }
  },[dataList]);

  const checkRequestedAmt = (val) => {
    const pendingAmts = Number(pendingAmt);
    if(pendingAmts < Number(val)){
      setIsModal(true);
    }else{
      setRequestAmt(val);
    }
  };

  const handleModalHide = () => {
    // history.push(`${baseUrl}/postSalesListing`);
    setRequestAmt(0);
    setIsModal(false);
  };

  const handleHoldModalHide = () => {
    setIsHoldModal(false);
    setModelForHold(false);
    setRemark('');
  };

  const handleErrorModal = () =>{
    setIsErrorModal(false);
  }

  const rejected = () =>{  
    if(match?.params?.id){
        setIsHoldModal(true);
        setModelForHold(true);
        setMakeStatus(3);
        setModelHeader('Reject');
    } 
  }

  // const rejected = () =>{
   
  //   if(match?.params?.id){
  //     (async () => {
  //       const data = {'payment_id' : match?.params?.id, 'status':3, 'remark':remark, 'update':isUpdate, 'hold_status':holdStatus};
  //       setSavedStatus('Rejected!')
  //       //console.log(data); return false;
  //       const res = await approvalVendorPaymentRequest(data);
  //       if (res) {
  //         if(res.message){
  //           setSavedStatus(res.message);
  //         }
          
  //         setSaveModal(true);
  //       }
  //     })();
  //   }
  // }

  const approved = () =>{
    
    if(match?.params?.id){
      (async () => {
        const data = {'payment_id' : match?.params?.id, 'status':2, 'remark':remark, 'update':isUpdate, 'hold_status':holdStatus};
        setSavedStatus('Approved')
        //console.log(data); return false;
        const res = await approvalVendorPaymentRequest(data);
        if (res) {
          if(res.message){
            setSavedStatus(res.message);
          }
          setSaveModal(true);
        }
      })();
    }
       
  }

  const holdAndApproved = () =>{  
    if(match?.params?.id){
        setIsHoldModal(true);
        setModelForHold(true);
        setMakeStatus(7);
        setModelHeader('Hold & Approved');
    } 
  }

  const handleModalMSMEHide = () => {
    setCheckMSME(false);
  };
  const approveMSMERequest = () =>{  
    if(match?.params?.id){
        
        setMSMEMsg('This is MSME vendor and invoice is older than 30days, so extra charge of MSME amount of Rs. '+dataList.invoice_data?.interest_amount+' (calculate basis 21% of Invoice Amount) would be applicable for delay payment. Are you sure to approve this request?');

        setCheckMSME(true);
    } 
  }
  const approveRequest = () =>{  
    if(match?.params?.id){
        setIsHoldModal(true);
        setModelForHold(true);
        setMakeStatus(2);
        setModelHeader('Approve Request');
    } 
  }

  const handleContinue = async () => {
    if(match?.params?.id){
      (async () => {
        const data = {'payment_id' : match?.params?.id, 'status':makeStatus, 'remark':remark, 'update':isUpdate, 'hold_status':holdStatus};
        setSavedStatus('Hold & Approved');
        //console.log(data); return false;
        setIsLoading(true);
        const res = await approvalVendorPaymentRequest(data);
        if (res) {
          if(res.message){
            setSavedStatus(res.message);
          }
          setIsLoading(false);
          setIsHoldModal(true);
          setModelForHold(false);
        }
      })();
    }
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="/dashboard/vendorPaymentRequestApprovalList" onClick={func} className="btn btn-transparent">
          {localization.returnToPaymentRequest}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };
   

  const handleSaveModalHide = () => {
    history.push(`${baseUrl}/vendorPaymentRequestApprovalList`);
    setIsModal(false);
  };
  
  return (
    <>
     
    <Fragment>
     <div className="panel-card card border-round container">
          <div className="card-header border-primary">
               <span className="vendorHeading">Request Details</span>
          </div>
          <div className="card-body">
          <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.vendorCode}
                  data={
                    dataList.invoice_data?.vendor_code
                      ? dataList.invoice_data.vendor_code
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.vendorName}
                  data={
                    dataList.invoice_data?.name_of_firm
                      ? dataList.invoice_data.name_of_firm
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.gstNumberHead}
                  data={
                    dataList.invoice_data?.gst_no
                      ? dataList.invoice_data.gst_no
                      : localization.na
                  }
                />
          </div>
          <hr/>
          <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.expense_basis}
                  data={
                    dataList.invoice_data?.expense_basis
                      ? dataList.invoice_data.expense_basis
                      : localization.na
                  }
                />
                { dataList.invoice_data?.expense_basis && dataList.invoice_data.expense_basis === 'PO' ? 
                  <>
                    <DivLayout
                      heading={localization.poNo}
                      data={
                        dataList.invoice_data?.po_number
                          ? dataList.invoice_data.po_number
                          : localization.na
                      }
                    />
                    <DivLayout
                        heading={localization.poAmt}
                        data={
                          dataList.invoice_data?.po_amount
                            ? dataList.invoice_data.po_amount
                            : localization.na
                        }
                      />
                  </>
                : null}
                <DivLayout
                  heading={localization.expense_type}
                  data={
                    dataList.invoice_data?.expense_type
                      ? dataList.invoice_data.expense_type
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.createdBy}
                  data={
                    dataList.invoice_data?.created_name
                      ? dataList.invoice_data.created_name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.invDescription}
                  data={
                    dataList.invoice_data?.description
                      ? dataList.invoice_data.description
                      : localization.na
                  }
                />
          </div>
          <hr/>
          <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.invoiceNo}
                  data={
                    dataList.invoice_data?.invoice_number
                      ? dataList.invoice_data.invoice_number
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.invoiceDate}
                  data={
                    dataList.invoice_data?.invoice_date
                      ? dataList.invoice_data.invoice_date
                      : localization.na
                  }
              />
               <div
                  className={'details-list'}
                > 
                <DocumentView
                  title={`Invoice`}
                  attachment={
                    dataList?.invoice_document
                      ? dataList?.invoice_document
                      : localization.na
                  }
                />
                </div> 

                <DivLayout
                  heading={localization.totalAmountIncludeTax}
                  data={
                    dataList.invoice_data?.total_amount
                      ? dataList.invoice_data.total_amount
                      : localization.na
                  }
              /> 
              <DivLayout
                  heading={localization.requestedAmt}
                  data={
                    dataList.invoice_data?.request_amount
                      ? dataList.invoice_data.request_amount
                      : localization.na
                  }
              /> 
           
           <DivLayout
                  heading={localization.requestedDate}
                  data={
                    dataList.invoice_data?.created_at
                      ? dataList.invoice_data.created_at.slice(0, 10)
                      : localization.na
                  }
              /> 

              
             {dataList.invoice_data?.approved_name ? <>
                <DivLayout
                  heading={localization.approvedBy}
                  data={
                    dataList.invoice_data?.approved_name
                      ?  <span style={{color:'green'}}>{dataList.invoice_data.approved_name}</span>
                      : <span style={{color:'green'}}>N/A</span>
                  }
              /> 
              <DivLayout
                  heading={localization.approvedDate}
                  data={
                    dataList.invoice_data?.approved_date
                      ? dataList.invoice_data?.approved_date
                      : <span style={{color:'green'}}>N/A</span>
                  }
              /> 
              
              
              </> : <>
              <DivLayout
                  heading={localization.approvedBy}
                  data={
                    dataList.invoice_data?.approved_by
                      ? dataList.invoice_data.approved_by
                      : <span style={{color:'orange'}}>Pending For Approval</span>
                  }
              /> 
              </>}
              <DivLayout
                  heading={localization.status}
                  data={
                    dataList.invoice_data?.status
                      ? dataList.invoice_data?.status
                      : localization.na
                  }
              /> 

              <DivLayout
                heading={localization.remark}
                data={
                  dataList.invoice_data?.remark
                    ? dataList.invoice_data?.remark
                    : localization.na
                }
              />
                                
              {dataList.invoice_data?.utr_number ? 
              <>
                <DivLayout
                  heading={localization.UTR_number}
                  data={
                    dataList.invoice_data?.utr_number
                      ? dataList.invoice_data.utr_number
                      : localization.na
                  }
                  /> 
                    <DivLayout
                  heading={localization.paymentDate}
                  data={
                    dataList.invoice_data?.payment_date
                      ? dataList.invoice_data.payment_date
                      : localization.na
                  }
                  /> 
              </>
                  
              :
                null
              }
                               
              
          </div>

          <hr/>
          <div className="details-listing detail_alignment added">
            <DivLayout
                  heading={localization.msmeRate}
                  data={
                    dataList.invoice_data?.interest_rate
                      ? dataList.invoice_data.interest_rate
                      : localization.na
                  }
              />
              <DivLayout
                  heading={localization.msmeAmount}
                  data={
                    dataList.invoice_data?.interest_amount
                      ? dataList.invoice_data.interest_amount
                      : localization.na
                  }
              />
              <DivLayout
                  heading={localization.msmeRemark}
                  data={
                    dataList.invoice_data?.late_fee_remark
                      ? dataList.invoice_data.late_fee_remark
                      : localization.na
                  }
              />
          </div>


          <hr/>

          <div className="details-listing detail_alignment added">
            <DivLayout
                  heading={localization.installationId}
                  data={
                    dataList.invoice_data?.installation_id
                      ? dataList.invoice_data.installation_id
                      : localization.na
                  }
              />

            <DivLayout
                  heading={localization.projectName}
                  data={
                    dataList.invoice_data?.project_name
                      ? dataList.invoice_data.project_name
                      : localization.na
                  }
              /> 
              {dataList?.installation_certificate && dataList?.installation_certificate != null && 
                <div
                    className={'details-list'}
                  > 
                  <DocumentView
                    title={`Installation Cerificate`}
                    attachment={
                      dataList?.installation_certificate
                        ? dataList?.installation_certificate
                        : localization.na
                    }
                  />
                  </div> 
              }  
              
              {dataList?.agreement_attachment && dataList?.agreement_attachment != null && 
                <div
                  className={'details-list'}
                > 
                <DocumentView
                  title={`Agreement Attachment`}
                  attachment={
                    dataList?.agreement_attachment
                      ? dataList?.agreement_attachment
                      : localization.na
                  }
                />
                </div>
              } 

                
              {dataList?.other_attachment && dataList?.other_attachment.length > 0 && 
              <> 
                {dataList?.other_attachment.map((doc, x) =>
                <div
                  className={'details-list'}
                > 
                <DocumentView
                  title={`Other Attachment ` + (x+1)}
                  attachment={doc}
                />
                </div>
                )} 
              </>                 
              }
          </div>
          <hr/> 

          {dataList.invoice_data?.status && (dataList.invoice_data?.status ==='Approval Pending' || dataList.invoice_data?.status ==='Hold') ? 
            <div className="row d-flex" style={{'paddingRight':'33%'}}>
              <div className="col-md-2">
                {(dataList?.checkMsme && dataList?.checkMsme == 1) ?
                   <button className="btn btn-success border-success" onClick={() => approveMSMERequest(true)}>
                    Approve MSME
                  </button>
                 
                  :
                  <button className="btn btn-success border-success" onClick={() => approveRequest(true)}>
                    Approve
                  </button>
                }
                
              </div>
              {dataList.invoice_data?.status !=='Hold' ? (
              <div className="col-md-2">
              <button className="btn btn-danger border-danger" onClick={() => rejected(true)}>
                  Reject
              </button>
              </div>
              ): null}
              {/* {dataList.invoice_data?.status ==='Approval Pending' && dataList.invoice_data?.is_modified == 0 ? (
                <div className="col-md-3">
                <button className="btn btn-warning border-warning" onClick={() => holdAndApproved(true)}>
                    Hold & Approve
                </button>
                </div>
              ): null} */}
          </div>
          :
           null 
          }
         

          </div>
      </div>
      
      
      <ModalPop
            title={`Alert`}
            show={checkMSME}
            handleModalHide={handleModalMSMEHide}
            keyboard
          >
            <div className="row text-center">
              
              <div className="col-12">
                <img src={Images?.ErrorImg} alt="" style={{width:"10%"}} />
              </div>
              <div className="col-12">
                <h5>{msmeMsg}</h5>
              </div>
              
              <div className="col-12">
                <button className="btn btn-success border-success" onClick={() => approveRequest(true)}>
                    Approve
                </button>
              </div>
            
            </div>
          </ModalPop>

     
      <ModalPop
            title={localization.warning}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
            <div className="text-center">
              
                <img src={Images?.alert} alt="" />
             
              <h5>Requested amount should be less than or equal to total amount!</h5>
             
            
            </div>
          </ModalPop>
          <ErrModalPop
            title={localization.error}
            show={isErrorModal}
            handleModalHide={handleErrorModal}
            keyboard
            backdrop
          >
            <div className="text-center">
              {parse(errorMsg)}
            </div>
          </ErrModalPop>
          <ModalPop
            title={localization.success}
            show={saveModal}
            handleModalHide={handleSaveModalHide}
            keyboard
          >
            <div className="text-center">
              
              <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
             
              <h5>{savedStatus}</h5>
             
            
            </div>
          </ModalPop>
          <ModalPop
            title={modelHeader}
            show={isHoldModal}
            handleModalHide={handleHoldModalHide}
          >
          {modelForHold && modelForHold === true ? (
          <Fragment>
            <div className="modal-body">
              <div className="text-center">
                <h5>{''}</h5>
                <div className="form-group col-md-10 d-inline-flex">
                  <ConstantInput
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    type="text"
                    handleChange={(val) => {
                      setRemark(val);
                    }}
                  />
                </div>
                <Button
                  className="btn btn-primary"
                  onClick={handleContinue}
                  disabled={!remark}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(modelHeader, handleHoldModalHide)}
          </Fragment>
        )}
          </ModalPop>
    </Fragment>
   </>
  );
};

export default PaymentDetails;
